import { ContentConnectorApollo, withRouter } from '@front-activerse/common-components';
import ContentContainer from './ContentContainer';
import { useLocation } from 'react-router-dom';

const ContentPage = () => {
  const location = useLocation();

  console.log('location.pathname.slice(1)', location.pathname.slice(1));

  return (
    <ContentConnectorApollo identifier={location.pathname.slice(1)}>
      {({ ...contentData }) => <ContentContainer {...contentData} />}
    </ContentConnectorApollo>
  );
};

export default withRouter(ContentPage);
